// src/context/recentContext.js
import { createContext, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

export const RecentContext = createContext(null);

const MAX_RECENT_ITEMS = 10;

function dedupeById(items, idKey = 'id') {
  const seen = new Set();
  const result = [];
  for (const item of items) {
    const key = item[idKey] || item._id || `${item.org_id || ''}:${item.name}`;
    if (!seen.has(key)) {
      seen.add(key);
      result.push(item);
    }
  }
  return result;
}

export const RecentProvider = ({ children }) => {
  const [recentProducts, setRecentProducts] = useState([]);
  const [recentOrgs, setRecentOrgs] = useState([]);
  const [pendingProductToOpen, setPendingProductToOpen] = useState(null);

  const addRecentProduct = useCallback((product, org) => {
    if (!product) return;
    console.log('RecentContext addRecentProduct - product:', product, 'org:', org);
    const entry = {
      id: product.id || product.sfId || product._id || product.name,
      name: product.name,
      org_id: product.org_id || org?.org_id,
      org_name: org?.name,
      timestamp: Date.now(),
      raw: { product, org },
    };
    console.log('RecentContext created entry:', entry);
    setRecentProducts((prev) => {
      const next = [entry, ...prev];
      const unique = dedupeById(next, 'id');
      return unique.slice(0, MAX_RECENT_ITEMS);
    });
  }, []);

  const addRecentOrg = useCallback((org) => {
    if (!org) return;
    const entry = {
      id: org.org_id || org._id || org.name,
      name: org.name,
      org_id: org.org_id,
      timestamp: Date.now(),
      raw: org,
    };
    setRecentOrgs((prev) => {
      const next = [entry, ...prev];
      const unique = dedupeById(next, 'id');
      return unique.slice(0, MAX_RECENT_ITEMS);
    });
  }, []);

  const value = useMemo(
    () => ({
      recentProducts,
      recentOrgs,
      addRecentProduct,
      addRecentOrg,
      pendingProductToOpen,
      setPendingProductToOpen,
    }),
    [recentProducts, recentOrgs, addRecentProduct, addRecentOrg, pendingProductToOpen]
  );

  return <RecentContext.Provider value={value}>{children}</RecentContext.Provider>;
};

RecentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
